import { db } from "../lib/firebase";
import { collection, getDocs } from "firebase/firestore";

function normalizeEmail(v = "") {
  return String(v).trim().toLowerCase();
}

export async function fixDuplicateEmployees() {
  const usersSnap = await getDocs(collection(db, "users"));
  const schedulesSnap = await getDocs(collection(db, "schedules"));

  const users = usersSnap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));

  const grouped = {};

  users.forEach((u) => {
    const email = normalizeEmail(u.email);
    if (!email) return;
    if (!grouped[email]) grouped[email] = [];
    grouped[email].push(u);
  });

  const report = [];

  for (const email of Object.keys(grouped)) {
    const matches = grouped[email];
    if (matches.length < 2) continue;

    const keep = matches[0];
    const remove = matches.slice(1);

    let refs = 0;

    schedulesSnap.docs.forEach((sched) => {
      const data = sched.data();

      Object.values(data).forEach((val) => {
        if (Array.isArray(val)) {
          val.forEach((id) => {
            if (remove.find((r) => r.id === id)) refs++;
          });
        }
      });

      if (data.__assignments) {
        Object.values(data.__assignments).forEach((arr) => {
          if (!Array.isArray(arr)) return;
          arr.forEach((a) => {
            if (remove.find((r) => r.id === a.employeeId)) refs++;
          });
        });
      }
    });

    report.push({
      email,
      keep: keep.id,
      remove: remove.map((r) => r.id),
      scheduleRefs: refs,
    });
  }

  console.table(report);

  alert(
    report.length
      ? `Found ${report.length} duplicate employee groups. Open browser console (F12) for details.`
      : "No duplicate employees found."
  );
}